import styles from '@activities/order/OrderLogActivity/components/OrderFooter/styles.module.scss';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { PaymentMethodKr } from '@models/order/extension';
import { OrderLogResponse } from '@models/order/orderLog';

interface Props {
    order: OrderLogResponse;
}

function Notes({ order }:Props) {
  const {
    paymentAmount, paymentMethod, totalAmount, totalDiscount, status, note,
  } = order;
  return (
        <Container>
            {note && (
                <Card spacing={16} fullWidth>
                    <Text size='lg' fontWeight='bold'>요청사항</Text>
                    <Text size='s'>
                        { note}
                    </Text>
                </Card>
            )}
            <Card fullWidth spacing={16}>
                <Text size='lg' fontWeight='bold'>결제 정보</Text>
                <Grid>
                    <Text color={colors.gray7} as='span'>결제수단</Text>
                    <Text color={colors.gray7} as='span' align='right'
                          className={status === 'CANCELLED' ? styles.canceled : ''}>
                        {PaymentMethodKr[paymentMethod]}
                    </Text>
                    <Text color={colors.gray7}>상품금액</Text>
                    <Text className={status === 'CANCELLED' ? styles.canceled : ''} align='right' color={colors.gray7}>
                        {totalAmount.toLocaleString()}원
                    </Text>
                    <Text color={colors.gray7}>할인금액</Text>
                    <Text className={status === 'CANCELLED' ? styles.canceled : ''} color={colors.gray7} align='right'>
                        -{totalDiscount.toLocaleString()}원
                    </Text>
                    <Divider/>
                    <Text fontWeight='bold'>결제금액</Text>
                    <Text size='xl' fontWeight='bold' align='right'
                          className={status === 'CANCELLED' ? styles.canceled : ''}>
                        {paymentAmount.toLocaleString()}원
                    </Text>
                </Grid>
            </Card>
        </Container>
  );
}

const Divider = styled.div`
    grid-column-start: 1;
    grid-column-end: 3;
    width: 100%;
    height: 1px;
    background-color: ${colors.gray2};
`;

const Container = styled(Column)`
    min-width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
    padding-bottom: 24px;
`;

const Card = styled(Column)`
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${colors.gray2};
    margin: 14px 16px 0;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    width: 100%;
    gap: 8px;
`;

export default Notes;
